import ContentfulLink, { PlatformTypes } from './contentful/ContentfulLink'
import { ContentfulExperimentConfig } from './ContentfulExperimentConfig'

interface ILink {
  id: string
  navigationPath: string
  scrollToHash: string
  experimentConfig?: ContentfulExperimentConfig[]
  openInNewTab?: boolean | null
  applicablePlatforms?: PlatformTypes[] | null
  liveShowId?: string
  preserveQueryParams?: boolean | null
  /**
   * Raw `url` field straight from Contentful — preserved separately from the
   * resolved `navigationPath` because some web flows (e.g. Live Event CTAs)
   * carry their canonical destination here as a fully-qualified URL with
   * query parameters (`?showId=…`) that the slug-derived `navigationPath`
   * doesn't capture.
   */
  url?: string | null
}

class Link implements ILink {
  id: string
  navigationPath: string
  scrollToHash: string
  experimentConfig?: ContentfulExperimentConfig[]
  openInNewTab?: boolean | null
  applicablePlatforms?: PlatformTypes[] | null
  liveShowId?: string
  preserveQueryParams?: boolean | null
  url?: string | null

  constructor({
    id,
    navigationPath,
    scrollToHash,
    experimentConfig,
    openInNewTab,
    applicablePlatforms,
    liveShowId,
    preserveQueryParams,
    url,
  }: ILink) {
    this.id = id
    this.navigationPath = navigationPath
    this.scrollToHash = scrollToHash
    this.experimentConfig = experimentConfig
    this.openInNewTab = openInNewTab
    this.applicablePlatforms = applicablePlatforms
    this.liveShowId = liveShowId
    this.preserveQueryParams = preserveQueryParams
    this.url = url
    return {
      ...this,
    }
  }

  static fromContentful(contentfulLink: ContentfulLink) {
    return new Link({
      id: contentfulLink.id,
      navigationPath: ContentfulLink.getLinkPath(contentfulLink),
      scrollToHash: contentfulLink.scrollToHash,
      experimentConfig: contentfulLink.experimentConfig,
      openInNewTab: contentfulLink.openInNewTab,
      applicablePlatforms: contentfulLink.applicablePlatforms,
      liveShowId: contentfulLink.liveShowId,
      preserveQueryParams: contentfulLink.preserveQueryParams,
      url: contentfulLink.url,
    })
  }
}

export default Link
